import {
  PersonDocument,
  PeopleDocument,
  useSendContactInviteMutation,
} from "@/features/people/graphql/generated";
import { ProjectDocument } from "@/features/projects/graphql/generated";
import { useToast } from "@/shared/contexts/toast.context";

export const useContactInvite = () => {
  const [sendContactInvite] = useSendContactInviteMutation();
  const { showToast } = useToast();

  const handleSendContactInvite = async (
    personId: number,
    projectId: number
  ) => {
    const result = await sendContactInvite({
      variables: { personId, projectId },
      refetchQueries: [PeopleDocument, ProjectDocument, PersonDocument],
    });
    if (result.data?.sendContactInvite) {
      showToast({
        type: "success",
        message: "Contact invite sent successfully",
      });
    }
  };

  return {
    handleSendContactInvite,
  };
};
